export namespace GraphType {
  export interface GraphTypeDescription {
    displayName: string;
    relationshipType: string;
  }

  const graphTypeLookup: ReadonlyMap<string, GraphTypeDescription> = new Map([
    ["funktionar", { displayName: "Board", relationshipType: "FUNKTIONAR" }],
    ["address", { displayName: "Address", relationshipType: "HAS_ADDRESS" }],
    ["phoneNumber", { displayName: "Phone", relationshipType: "HAS_PHONE" }],
    ["bankAccount", { displayName: "Bank Account", relationshipType: "HAS_BANK_ACCOUNT" }],
    ["carRegNumber", { displayName: "Car Registration", relationshipType: "HAS_CAR_REG_NUMBER" }],
    ["email", { displayName: "Email", relationshipType: "HAS_EMAIL" }],
    ["Case", { displayName: "Case Number", relationshipType: "HAS_CASE" }],
    ["all", { displayName: "All", relationshipType: "" }]
  ]);

  export const getDisplayName = (graphType: string): string => {
    return graphTypeLookup.get(graphType)?.displayName ?? graphType;
  }

  export const getRelationshipType = (graphType: string): string => {
    return graphTypeLookup.get(graphType)?.relationshipType ?? graphType;
  }

  export const getGraphType = (relationshipType: string): string => {
    var result = undefined;

    graphTypeLookup.forEach((value, key) => {
      if (value.relationshipType === relationshipType) {
        result = key;
      }
    });

    return result ?? relationshipType;
  }
}